// import { useState, useEffect, useRef } from "react";
// import { useSetting } from "../../controllers/SettingsContext";

// interface Country {
//   id: number | string;
//   name: string;
// }

// interface State {
//   id: number | string;
//   name: string;
// }

// interface ContactInfoFormProps {
//   type?: "company" | "individual";
// }

// export function ContactInfoForm({ type = "company" }: ContactInfoFormProps) {
//   const {
//     companyPhone,
//     setCompanyPhone,
//     companyAddress,
//     setCompanyAddress,
//     businessZone,
//     setBusinessZone,
//     selectedCountry,
//     setSelectedCountry,
//     selectedState,
//     setSelectedState,
//     countries,
//     states,
//     countriesLoading,
//     statesLoading,
//   } = useSetting();

//   const [showCountryDropdown, setShowCountryDropdown] = useState(false);
//   const [showStateDropdown, setShowStateDropdown] = useState(false);
//   const countryRef = useRef<HTMLDivElement>(null);
//   const stateRef = useRef<HTMLDivElement>(null);

//   console.log("Countries:", countries);
//   console.log("Type:", typeof countries);

//   useEffect(() => {
//     const handleClickOutside = (event: MouseEvent) => {
//       if (countryRef.current && !countryRef.current.contains(event.target as Node)) {
//         setShowCountryDropdown(false);
//       }
//       if (stateRef.current && !stateRef.current.contains(event.target as Node)) {
//         setShowStateDropdown(false);
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);

//   // dynamic labels and placeholders
//   const labels = {
//     phone: type === "company" ? "Phone Number" : "Phone  Number",
//     address: type === "company" ? "Head Office Address" : "Head Office Address",
//     businessZone: type === "company" ? "Business Zone" : "Business Zone",
//     country: "Country",
//     state: "State",
//     phonePlaceholder: "+123 456 7890",
//     addressPlaceholder: type === "company" ? "Company HQ Address" : "Enter your address",
//     businessZonePlaceholder: type === "company" ? "Business zone" : "Enter your address",
//   };

//   return (
//     <div className="space-y-6 relative">
//       <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//         {/* Phone */}
//         <div>
//           <label className="block text-sm font-medium mb-1">{labels.phone}</label>
//           <input
//             type="tel"
//             value={companyPhone || ""}
//             onChange={(e) => setCompanyPhone(e.target.value)}
//             placeholder={labels.phonePlaceholder}
//             className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm bg-white"
//           />
//         </div>

//         {/* address */}
//         <div>
//           <label className="block text-sm font-medium mb-1">{labels.address}</label>
//           <input
//             type="text"
//             value={companyAddress || ""}
//             onChange={(e) => setCompanyAddress(e.target.value)}
//             placeholder={labels.addressPlaceholder}
//             className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm bg-white"
//           />
//         </div>

//         {/* business zone */}
//         <div>
//           <label className="block text-sm font-medium mb-1">{labels.businessZone}</label>
//           <input
//             type="text"
//             value={businessZone || ""}
//             onChange={(e) => setBusinessZone(e.target.value)}
//             placeholder={labels.businessZonePlaceholder}
//             className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm bg-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
//           />
//         </div>
//       </div>

//       {/* country and state */}
//       <div className="grid grid-cols-1 md:grid-cols-2 gap-4 relative">
//         {/* country */}
//         <div ref={countryRef} className="relative">
//           <label className="block text-sm font-medium mb-1">{labels.country}</label>
//           <div
//             onClick={() => setShowCountryDropdown(!showCountryDropdown)}
//             className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm bg-white cursor-pointer flex justify-between items-center"
//           >
//             <span>
//               {countriesLoading
//                 ? "Loading countries..."
//                 : (countries.data.find((c: Country) => c.id.toString() === selectedCountry)?.name ||
//                   "Select country")}
//             </span>
//           </div>
//           {showCountryDropdown && (
//             <ul className="absolute bottom-full mb-1 left-0 w-full bg-white border border-gray-200 rounded-lg shadow-md max-h-40 overflow-y-auto z-20">
//               {countries.map((c: Country) => (
//                 <li
//                   key={c.id}
//                   onClick={() => {
//                     setSelectedCountry(c.id.toString());
//                     setShowCountryDropdown(false);
//                   }}
//                   className={`px-3 py-2 text-sm hover:bg-blue-50 cursor-pointer ${selectedCountry === c.id.toString() ? "bg-blue-100" : ""
//                     }`}
//                 >
//                   {c.name}
//                 </li>
//               ))}
//             </ul>
//           )}
//         </div>

//         {/* state */}
//         <div ref={stateRef} className="relative">
//           <label className="block text-sm font-medium mb-1">{labels.state}</label>
//           <div
//             onClick={() =>
//               selectedCountry && setShowStateDropdown(!showStateDropdown)
//             }
//             className={`w-full border border-gray-300 rounded-lg px-3 py-2 text-sm bg-white cursor-pointer flex justify-between items-center ${!selectedCountry ? "opacity-50 cursor-not-allowed" : ""
//               }`}
//           >
//             <span>
//               {!selectedCountry
//                 ? "Select a country first"
//                 : statesLoading
//                   ? "Loading states..."
//                   : (states.find((s: State) => s.id.toString() === selectedState)?.name ||
//                     "Select state")}
//             </span>
//           </div>
//           {showStateDropdown && (
//             <ul className="absolute bottom-full mb-1 left-0 w-full bg-white border border-gray-200 rounded-lg shadow-md max-h-40 overflow-y-auto z-20">
//               {states.map((s: State) => (
//                 <li
//                   key={s.id}
//                   onClick={() => {
//                     setSelectedState(s.id.toString());
//                     setShowStateDropdown(false);
//                   }}
//                   className={`px-3 py-2 text-sm hover:bg-blue-50 cursor-pointer ${selectedState === s.id.toString() ? "bg-blue-100" : ""
//                     }`}
//                 >
//                   {s.name}
//                 </li>
//               ))}
//             </ul>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// }



import { useState, useEffect, useRef } from "react";
import { useSetting } from "../../controllers/SettingsContext";

interface Country {
  id: number | string;
  name: string;
}

interface State {
  id: number | string;
  name: string;
}

interface ContactInfoFormProps {
  type?: "company" | "individual";
}

export function ContactInfoForm({ type = "company" }: ContactInfoFormProps) {
  const {
    companyPhone,
    setCompanyPhone,
    supportEmail,
    setSupportEmail,
    companyAddress,
    setCompanyAddress,
    businessZone,
    setBusinessZone,
    selectedCountry,
    setSelectedCountry,
    selectedState,
    setSelectedState,
    countries,
    states,
    countriesLoading,
    statesLoading,
  } = useSetting();

  const [showCountryDropdown, setShowCountryDropdown] = useState(false);
  const [showStateDropdown, setShowStateDropdown] = useState(false);
  const countryRef = useRef<HTMLDivElement>(null);
  const stateRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (countryRef.current && !countryRef.current.contains(event.target as Node)) {
        setShowCountryDropdown(false);
      }
      if (stateRef.current && !stateRef.current.contains(event.target as Node)) {
        setShowStateDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const labels = {
    phone: type === "company" ? "Phone Number" : "Phone Number",
    address: type === "company" ? "Head Office Address" : "Head Office Address",
    businessZone: type === "company" ? "Business Zone" : "Business Zone",
    country: "Country",
    state: "State",
    phonePlaceholder: "+123 456 7890",
    addressPlaceholder: type === "company" ? "Company HQ Address" : "Enter your address",
    businessZonePlaceholder: type === "company" ? "Business zone" : "Enter your address",
  };

  const countriesList: Country[] = Array.isArray(countries)
    ? countries
    : Array.isArray(countries?.data)
    ? countries.data
    : [];

  const statesList: State[] = Array.isArray(states)
    ? states
    : Array.isArray(states?.data)
    ? states.data
    : [];

  return (
    <div className="space-y-6 relative">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Phone */}
        <div>
          <label className="block text-sm font-medium mb-1">{labels.phone}</label>
          <input
            type="tel"
            value={companyPhone || ""}
            onChange={(e) => setCompanyPhone(e.target.value)}
            placeholder={labels.phonePlaceholder}
            className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm bg-white"
          />
        </div>

        {/* Support Email */}
        <div>
          <label className="block text-sm font-medium mb-1">Support Email</label>
          <input
            type="email"
            value={supportEmail || ""}
            onChange={(e) => setSupportEmail(e.target.value)}
            placeholder="support@company.com"
            className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm bg-white"
          />
        </div>

        {/* Address */}
        <div>
          <label className="block text-sm font-medium mb-1">{labels.address}</label>
          <input
            type="text"
            value={companyAddress || ""}
            onChange={(e) => setCompanyAddress(e.target.value)}
            placeholder={labels.addressPlaceholder}
            className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm bg-white"
          />
        </div>

        {/* Business Zone */}
        <div>
          <label className="block text-sm font-medium mb-1">{labels.businessZone}</label>
          <input
            type="text"
            value={businessZone || ""}
            onChange={(e) => setBusinessZone(e.target.value)}
            placeholder={labels.businessZonePlaceholder}
            className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm bg-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          />
        </div>
      </div>

      {/* Country and State */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 relative">
        {/* Country */}
        <div ref={countryRef} className="relative">
          <label className="block text-sm font-medium mb-1">{labels.country}</label>
          <div
            onClick={() => setShowCountryDropdown(!showCountryDropdown)}
            className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm bg-white cursor-pointer flex justify-between items-center"
          >
            <span>
              {countriesLoading
                ? "Loading countries..."
                : countriesList.find(
                    (c: Country) => c.id.toString() === selectedCountry
                  )?.name || "Select country"}
            </span>
          </div>
          {showCountryDropdown && (
            <ul className="absolute bottom-full mb-1 left-0 w-full bg-white border border-gray-200 rounded-lg shadow-md max-h-40 overflow-y-auto z-20">
              {countriesList.map((c: Country) => (
                <li
                  key={c.id}
                  onClick={() => {
                    setSelectedCountry(c.id.toString());
                    setShowCountryDropdown(false);
                  }}
                  className={`px-3 py-2 text-sm hover:bg-blue-50 cursor-pointer ${
                    selectedCountry === c.id.toString() ? "bg-blue-100" : ""
                  }`}
                >
                  {c.name}
                </li>
              ))}
            </ul>
          )}
        </div>

        {/* State */}
        <div ref={stateRef} className="relative">
          <label className="block text-sm font-medium mb-1">{labels.state}</label>
          <div
            onClick={() =>
              selectedCountry && setShowStateDropdown(!showStateDropdown)
            }
            className={`w-full border border-gray-300 rounded-lg px-3 py-2 text-sm bg-white cursor-pointer flex justify-between items-center ${
              !selectedCountry ? "opacity-50 cursor-not-allowed" : ""
            }`}
          >
            <span>
              {!selectedCountry
                ? "Select a country first"
                : statesLoading
                ? "Loading states..."
                : statesList.find(
                    (s: State) => s.id.toString() === selectedState
                  )?.name || "Select state"}
            </span>
          </div>
          {showStateDropdown && (
            <ul className="absolute bottom-full mb-1 left-0 w-full bg-white border border-gray-200 rounded-lg shadow-md max-h-40 overflow-y-auto z-20">
              {statesList.map((s: State) => (
                <li
                  key={s.id}
                  onClick={() => {
                    setSelectedState(s.id.toString());
                    setShowStateDropdown(false);
                  }}
                  className={`px-3 py-2 text-sm hover:bg-blue-50 cursor-pointer ${
                    selectedState === s.id.toString() ? "bg-blue-100" : ""
                  }`}
                >
                  {s.name}
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </div>
  );
}